import { createSlice } from '@reduxjs/toolkit';
// import { changeShipmentStatus } from './api';
import { downloadIndiaInvoice, getFacilityShipments, getShipmentPackingFile } from './api';

export const IndiaInvoiceManagementSlice = createSlice({

    name: 'indiaInvoiceManagementSlice',
    initialState: {
        loading: false,
        error: '',
        data: [],
        downloadPackingFileSuccessMessage: '',
        downloadInvoiceSuccessMessage: '',
    },
    reducers: {
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clear: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getFacilityShipments.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getFacilityShipments.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.data
        })
        builder.addCase(getFacilityShipments.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        
        builder.addCase(getShipmentPackingFile.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getShipmentPackingFile.fulfilled, (state, action) => {
            state.loading = false;
            state.downloadPackingFileSuccessMessage = 'Successfully downloaded packing file'
        })
        builder.addCase(getShipmentPackingFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        
        builder.addCase(downloadIndiaInvoice.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(downloadIndiaInvoice.fulfilled, (state, action) => {
            state.loading = false;
            state.downloadInvoiceSuccessMessage = 'Successfully downloaded Invoice'
        })
        builder.addCase(downloadIndiaInvoice.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
    }
})

export const { clearError, clear } = IndiaInvoiceManagementSlice.actions

export default IndiaInvoiceManagementSlice.reducer